var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../framework/Framework';
export class Lightbox {
    static init() {
        if (Lightbox.isInitialized)
            return;
        Lightbox.isInitialized = true;
        Lightbox.htmlElement = $('#lightbox');
        Lightbox.htmlContainerElement = $('#lightbox-scrollarea .content');
        $('#button-close-lightbox').on('click', (event, item) => {
            event.preventDefault();
            Lightbox.hide();
        });
        Lightbox.isInitialized = true;
    }
    static hide() {
        Lightbox.htmlElement.addClass('d-none');
        $('body').removeClass('lg-on');
    }
    static show(html) {
        Lightbox.htmlContainerElement.empty();
        Lightbox.htmlElement.removeClass('d-none');
        $('body').addClass('lg-on');
        Lightbox.htmlContainerElement.append(html);
    }
    static load(url) {
        return __awaiter(this, void 0, void 0, function* () {
            var html = yield $.httpRequest({
                url: url,
                type: 'POST',
                body: { mode: 'ajax' },
                dataType: 'html',
            });
            Lightbox.show(html);
        });
    }
    static compare(dataMode, cart) {
        return __awaiter(this, void 0, void 0, function* () {
            var species = [];
            cart.forEach((item) => {
                species.push(parseInt(item.reference.replace('#species-', '')));
            });
            var html = yield $.httpRequest({
                url: location.href,
                type: 'POST',
                body: { mode: dataMode, speciesList: species.join(',') },
                dataType: 'html',
            });
            Lightbox.show(html);
        });
    }
}
Lightbox.isInitialized = false;
